export default __webpack_public_path__ + "static/media/clay-banks.340ed2fd.jpg";